import { render } from "./AddMerchantModal.vue?vue&type=template&id=37ad1c60&scoped=true"
import script from "./AddMerchantModal.vue?vue&type=script&lang=js"
export * from "./AddMerchantModal.vue?vue&type=script&lang=js"

import "./AddMerchantModal.vue?vue&type=style&index=0&id=37ad1c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ad1c60"]])

export default __exports__